import { render, staticRenderFns } from "./LaboratorySearch.html?vue&type=template&id=25f4fce4&external"
import script from "./LaboratorySearch.vue?vue&type=script&lang=js"
export * from "./LaboratorySearch.vue?vue&type=script&lang=js"
import style0 from "./LaboratorySearch.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports